import { render, staticRenderFns } from "./paymentbar.vue?vue&type=template&id=3e6a23dd&scoped=true&"
import script from "./paymentbar.vue?vue&type=script&lang=js&"
export * from "./paymentbar.vue?vue&type=script&lang=js&"
import style0 from "./paymentbar.vue?vue&type=style&index=0&id=3e6a23dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6a23dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\linlin\\paymentbar\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e6a23dd')) {
      api.createRecord('3e6a23dd', component.options)
    } else {
      api.reload('3e6a23dd', component.options)
    }
    module.hot.accept("./paymentbar.vue?vue&type=template&id=3e6a23dd&scoped=true&", function () {
      api.rerender('3e6a23dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/paymentbar.vue"
export default component.exports